import React from 'react'
import PropTypes from 'prop-types'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles(theme => ({
    bookingColumn: {
        width: '100%',
        // "@media (max-width: 1200px)": {
        '@media (max-width: 1400px)': {
            minWidth: '30% !important',
            maxWidth: '30% !important',
            marginRight: '3% !important',
        },
        '@media (max-width: 900px)': {
            minWidth: '100% !important',
            maxWidth: '100% !important',
            marginRight: '0% !important',
        },
    },
}))

const BookingColumn = ({ children, minWidth, maxWidth, marginRight }) => {
    const classes = useStyles()

    return (
        <span className={classes.bookingColumn} style={{ minWidth, maxWidth, marginRight }}>
            {children}
        </span>
    )
}

BookingColumn.propTypes = {
    minWidth: PropTypes.string,
    maxWidth: PropTypes.string,
    marginRight: PropTypes.string,
}

export default BookingColumn
